import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../Symbols/Title';
import Seat from './Seat';
import Party from './Party';
import { Senate, Seating, Seats, Groups } from './styles';

export default class SenateComposition extends React.PureComponent {

	render() {
		const parties = {};
		const group = this.props.senators.reduce((data, senator) => {
			const party = senator.proposingParty ? senator.proposingParty : senator.party;
			const id = party.id
			if (data.indexOf(id) === -1) {
				data.push(id);
				parties[id] = Object.assign({ senators: 0 }, party);
			}
			parties[id].senators++;
			return data;
		}, []);

		return <Senate>
			<Title>Složení senátu</Title>
			<Seating>
				<Seats>
					{this.props.senators.map(item => <Seat key={item.area.id} {...item} />)}
				</Seats>
			</Seating>
			<Groups>
				{group.map(id => <Party key={id} {...parties[id]} />)}
			</Groups>
		</Senate>
	}

}

SenateComposition.propTypes = {
	senators: PropTypes.arrayOf(PropTypes.shape({
		area: PropTypes.shape({
			id: PropTypes.number.isRequired,
			name: PropTypes.string.isRequired
		}).isRequired,
		party: PropTypes.shape({
			id: PropTypes.number.isRequired,
			name: PropTypes.string.isRequired,
			shortcut: PropTypes.string.isRequired
		}).isRequired,
		name: PropTypes.string.isRequired,
		lastName: PropTypes.string.isRequired
	})).isRequired
};
